import { useWhitelabelConfig } from '../../services/useWhitelabelConfig';

import NavBar, { TNavBar } from './NavBar';

export default function NavBarForTenant(props: Omit<TNavBar, 'navBarConfig'>) {
  const {
    wlConfig: { navBarConfig },
  } = useWhitelabelConfig();

  return <NavBar {...props} navBarConfig={navBarConfig} />;
}
